import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../../../../app/redux/hooks';
import { formatDateOnly } from '../../../../../../../utils/commonFunctions';

export const useOverSpeedHooks = (vehicles: any, urls: { getVehicles :any}) => {
  const roleType = localStorage.getItem('role');

  const [type, setType] = useState<string>('');
  const [filteredRow, setFilteredRow] = useState<null | any>();
  const [tourismRows, setTourismRows] = useState([]);
  const [open, setOpen] = useState<boolean>(false);
  const [tabValue, setTabValue] = useState(0);
  const [vehicleType, setVehicleType] = useState(
    roleType === 'ROLE_LOGISTICS'
      ? 'Logistics'
      : roleType === 'OPERATOR_ADMIN'
      ? 'Autoplanner'
      : 'Yaantrac'
  );

  const dispatch = useAppDispatch();
  const handleVehicle = async (e: any, newValue: any) => {
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        setVehicleType('Yaantrac');
        await dispatch(urls?.getVehicles('all'));
        break;
      case 1:
        setVehicleType('Autoplanner');
        await dispatch(urls?.getVehicles('tourism'));
        break;
      case 2:
        setVehicleType('Truck management');
        break;
      default:
        break;
    }
  };

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
  };

  const handleUpdateIcon = (row: any, event: any) => {
    setType(`Update Autoplanner`);
    handleUpdate(row);
    setFilteredRow(row);
    setOpen(true);
  };

  useEffect(() => {
    if (vehicles?.data?.length > 0 && vehicleType === 'Yaantrac') {
      let mappedRows = vehicles?.data?.map((row: any, index: number) => ({
        ...row,
        sNo: index + 1,
        vehicleRegistrationDate: formatDateOnly(row?.vehicleRegistrationDate),
        vehicleExpirationDate: formatDateOnly(row?.vehicleExpirationDate),
        lastServicedDate: formatDateOnly(row?.lastServicedDate),
        lastServicedDateEpoch: row?.lastServicedDate,
        dotInspectionDate: formatDateOnly(row?.dotInspectionDate),
        dotInspectionDateEpoch: row?.dotInspectionDate,
        insuranceExpiryDate: formatDateOnly(row?.insuranceExpiryDate),
        insuranceExpiryDateEpoch: row?.insuranceExpiryDate,
        freewaySpeedLimit: row?.freewaySpeedLimit ? row?.freewaySpeedLimit : '-',
        nonfreewaySpeedLimit: row?.nonfreewaySpeedLimit ? row?.nonfreewaySpeedLimit : '-'
      }));
    } else if (vehicles?.data?.length > 0 && vehicleType === 'Autoplanner') {
      let mappedRows = vehicles?.data?.map((row: any, index: number) => ({
        ...row,
        sNo: index + 1
      }));
      setTourismRows(mappedRows);
    } else {
      setTourismRows([]);
    }
  }, [vehicles]);

  return {
    handleUpdate,
    handleVehicle,
    handleUpdateIcon,
    vehicleType,
    tabValue,
    tourismRows,
    type,
    setOpen,
    open,
    filteredRow
  };
};
